import { render, staticRenderFns } from "./PickAnswerContent.vue?vue&type=template&id=75aa53e0&scoped=true&"
import script from "./PickAnswerContent.vue?vue&type=script&lang=js&"
export * from "./PickAnswerContent.vue?vue&type=script&lang=js&"
import style0 from "./PickAnswerContent.vue?vue&type=style&index=0&id=75aa53e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75aa53e0",
  null
  
)

export default component.exports